<template>
    <b-navbar-nav class="m-0 p-0">
        <b-nav-item-dropdown id="nav7_down" class="m-0 p-0" right>
            <template slot="button-content" >
                <span  class="font-default-color m-0 p-0">{{username}}</span></template>
            <b-dropdown-item @click="setting()"><b-icon icon="gear-fill" aria-hidden="true"></b-icon>ตั้งค่า</b-dropdown-item>
            <b-dropdown-item @click="logout()"><b-icon icon="box-arrow-right"></b-icon>ออกจากระบบ</b-dropdown-item>
        </b-nav-item-dropdown>
    </b-navbar-nav>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "ProfileStatus",
        methods: {
            // logout(){
            //     const path = `/login`
            //     if (this.$route.path !== path) this.$router.push(path)
            // }
            logout() {
                console.log(this.username)
                this.$store.dispatch('Auth/logout').then(() => {
                    this.$router.push('/')
                })
            },
            setting(){
              const path = `/setting`
              if (this.$route.path !== path) this.$router.push(path)
            }
        },
        computed: {
            ...mapState({
                access_token: state => state.Auth.access_token,
                username:state => state.Auth.username
            })
        }
    }
</script>

<style scoped>

</style>
